import React, { useState } from "react";
import cn from "classnames";

import { Generic } from "types/filters-store.types";

import { Icon } from "@trussworks/react-uswds";
import { MultiSelectCheckbox } from "components/LibraryComponents/Components";

import { GroupedMSAFilterTerm } from "./query";

// styles
import styles from "./MSADialog.module.scss";

type MSAAccordionProps = {
  data: GroupedMSAFilterTerm;
  open: boolean;
  selectedItems: Generic[];
  handleAccordionOpen: (state: string) => void;
  handleChange: (items: Generic[]) => void;
};

export default function MSAAccordion({
  data,
  open,
  selectedItems,
  handleAccordionOpen,
  handleChange,
}: MSAAccordionProps) {
  return (
    <div className={cn(styles["msa-accordion"])}>
      <div
        className={styles["msa-accordion-head"]}
        onClick={() => handleAccordionOpen(data.state)}
      >
        <p className={styles["heading"]}>{data.state}</p>
        <Icon.ArrowDropDown
          className={cn(styles["icon"], {
            [styles["open"]]: open,
          })}
          aria-label="accordion arrow"
        />
      </div>

      {open && (
        <div className={styles["msa-accordion-body"]}>
          <div className={styles["list"]}>
            <MultiSelectCheckbox
              className={styles["list-wrapper"]}
              items={data.msas}
              // checkedItems={counties}
              checkedItems={selectedItems}
              handleChange={handleChange}
              isInnerHtml
              hideOnly
            />
          </div>
        </div>
      )}
    </div>
  );
}
